export const API = "https://bingo-api.cslplasma-mobile.com";

export const FIND_GAME_SESSION = `${API}/admin/findSession`;

export const FIND_GAMESESSION_ID = `${API}/admin/findSessionID`;

export const CREATE_GAME = `${API}/createSession/variant75`;